import { Col, Row } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classNames from 'classnames';
import AiSettingsIcon from '@/app/common/components/AiSettingsIcon';
import HelpTooltip from '@/app/common/components/HelpTooltip';

const AI_ACCENT = '#a855f7';

const ModeOptionCard = ({
  id,
  label,
  checked,
  active = false,
  variant,
  tooltip,
  onChange
}) => {
  const isAi = variant === 'ai';

  return (
    <label
      className={classNames(
        'd-flex flex-row-reverse align-items-center gap-2 w-100 m-0 py-2 px-2 rounded-3 cursor-pointer user-select-none',
        {
          'border border-primary': active && !isAi,
          border: !active
        }
      )}
      style={
        active && isAi
          ? {
              border: `1px solid ${AI_ACCENT}`,
              backgroundColor: 'rgba(168, 85, 247, 0.06)',
              boxShadow: '0 0 0 1px rgba(168, 85, 247, 0.12)'
            }
          : active && !isAi
            ? {
                backgroundColor: 'rgba(var(--falcon-primary-rgb), 0.08)',
                boxShadow: '0 0 0 1px rgba(var(--falcon-primary-rgb), 0.12)'
              }
            : undefined
      }
    >
      <input
        type="radio"
        name="clustering-mode"
        id={id}
        className="form-check-input flex-shrink-0 m-0"
        checked={checked}
        onChange={onChange}
        style={
          checked
            ? {
                backgroundColor: isAi ? AI_ACCENT : 'var(--falcon-primary)',
                borderColor: isAi ? AI_ACCENT : 'var(--falcon-primary)'
              }
            : undefined
        }
      />
      <span className="flex-grow-1 d-inline-flex align-items-center gap-1 min-w-0">
        <span className="fs--1 d-inline-flex align-items-center gap-1 lh-sm">
          {label}
        </span>
        <HelpTooltip
          className="ms-0 lh-1 flex-shrink-0"
          icon="info-circle"
          html={tooltip}
        />
      </span>
      <span
        className={classNames(
          'd-inline-flex align-items-center justify-content-center rounded-3 flex-shrink-0',
          !isAi && 'text-primary'
        )}
        style={{
          width: '2rem',
          height: '2rem',
          ...(isAi
            ? {
                backgroundColor: 'rgba(168, 85, 247, 0.14)',
                color: AI_ACCENT
              }
            : {
                backgroundColor: 'rgba(var(--falcon-primary-rgb), 0.14)'
              })
        }}
      >
        {isAi ? (
          <AiSettingsIcon size={16} />
        ) : (
          <FontAwesomeIcon icon="project-diagram" className="fs--1" />
        )}
      </span>
    </label>
  );
};

export default function ClusteringModeSelector({ mode, onChange }) {
  return (
    <div className="m-0 p-0">
      <Row className="gx-2 gy-0 m-0">
        <Col xs={6} className="m-0">
          <ModeOptionCard
            id="clustering-mode-hierarchical"
            variant="tree"
            label="خوشه‌بندی"
            checked={mode === 'herachical'}
            active={mode === 'herachical'}
            tooltip={
              <>
                در خوشه‌بندی، تعداد خوشه‌های کلمات به‌طور خودکار مشخص میشه و این
                خوشه‌ها به‌صورت تودرتو و به شکل درختی نمایش داده می‌شن.
              </>
            }
            onChange={() => onChange('herachical')}
          />
        </Col>
        <Col xs={6} className="m-0">
          <ModeOptionCard
            id="clustering-mode-ai"
            variant="ai"
            label="خوشه‌بندی با AI"
            checked={mode === 'ai'}
            active={mode === 'ai'}
            tooltip={
              <>
                در این روش، خوشه‌بندی کلمات با استفاده از هوش مصنوعی انجام
                می‌شه. توجه کنید این فرایند زمان‌بره و ممکنه بین ۱۰ دقیقه تا ۲
                ساعت طول بکشه.
              </>
            }
            onChange={() => onChange('ai')}
          />
        </Col>
      </Row>
    </div>
  );
}
